import { Paperclip } from 'lucide-react';
import { entriesApi, type Entry } from '../../lib/api.js';
import { ReceiptsDialog } from '../../app/receipts-dialog.js';

/// Comprovantes de uma compra do Investimento, na tela comum de comprovantes.
export function EntryReceiptsDialog({
  entry,
  timeZone,
  canManage,
  onClose,
}: {
  entry: Entry;
  timeZone: string;
  canManage: boolean;
  onClose: () => void;
}) {
  return (
    <ReceiptsDialog
      source={{
        queryKey: ['company', 'receipts', entry.id],
        list: () => entriesApi.receipts(entry.id),
        attach: (file) => entriesApi.attachReceipt(entry.id, file),
        remove: entriesApi.removeReceipt,
        fileUrl: entriesApi.receiptFileUrl,
      }}
      description={`${entry.description} · anexe o PDF ou a foto da compra.`}
      emptyText="Nenhum comprovante anexado a esta compra."
      timeZone={timeZone}
      canManage={canManage}
      onClose={onClose}
    />
  );
}

export { Paperclip as ReceiptIcon };
